import React from "react";

import styles from "./PolicyPage.module.css";

export default function WebPolicyPage() {
	return (
		<div className={styles["policy-container"]}>
			<main className={styles["policy-content"]}>
				<div>
					<p className={styles["policy-text-header"]}>
						WEBSITE TERMS AND CONDITIONS OF USE
					</p>
					<p className={styles["policy-text-section-title"]}>
						1. About the Website
					</p>
					<p className={styles["policy-text"]}>
						(a) Welcome to worldseriesofmahjong.com.au (Website).
						The Website is World Series of Mahjong member's login
						platform (Services).
					</p>
					<p className={styles["policy-text"]}>
						(b) The Website is operated by Together Entertainment
						Pty Ltd (ACN 687 608 135). Access to and use of the
						Website, or any of its associated Products or Services,
						is provided by Together Entertainment Pty Ltd. Please
						read these terms and conditions (Terms) carefully. By
						using, browsing and/or reading the Website, this
						signifies that you have read, understood and agree to be
						bound by the Terms. If you do not agree with the Terms,
						you must cease usage of the Website, or any of Services,
						immediately.
					</p>
					<p className={styles["policy-text"]}>
						(c) Together Entertainment Pty Ltd reserves the right to
						review and change any of the Terms by updating this page
						at its sole discretion. When Together Entertainment Pty
						Ltd updates the Terms, it will use reasonable endeavours
						to provide you with notice of updates to the Terms. Any
						changes to the Terms take immediate effect from the date
						of their publication. Before you continue, we recommend
						you keep a copy of the Terms for your records.
					</p>
					<p className={styles["policy-text"]}>
						(d) You agree that may, in its sole discretion and
						without prior notice, modify, discontinue, or restrict
						the use of any portion of the Website or Services,
						including the availability of any features, database, or
						content. shall not be liable to you or to any third
						party for any modification, suspension, or
						discontinuance of the Website or Services.
					</p>
					<p className={styles["policy-text-section-title"]}>
						2. Acceptance of the Terms
					</p>
					<p className={styles["policy-text"]}>
						You accept the Terms by remaining on the Website. You
						may also accept the Terms by clicking to accept or agree
						to the Terms where this option is made available to you
						by Together Entertainment Pty Ltd in the user interface.
					</p>
					<p className={styles["policy-text-section-title"]}>
						3. Registration to use the Services
					</p>
					<p className={styles["policy-text"]}>
						(a) In order to access the Services, you must first
						register for an account through the Website or Mobile
						Apps (Account).
					</p>
					<p className={styles["policy-text"]}>
						(b) As part of the registration process, or as part of
						your continued use of the Services, you may be required
						to provide personal information about yourself (such as
						identification or contact details), including:
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(i) Email address
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(ii) Mailing address
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(iii) Telephone number
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(iv) Password
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(v) Bank Account Details
					</p>
					<p className={styles["policy-text"]}>
						(c) You warrant that any information you give to
						Together Entertainment Pty Ltd in the course of
						completing the registration process will always be
						accurate, correct and up to date.
					</p>
					<p className={styles["policy-text"]}>
						(d) Once you have completed the registration process,
						you will be a registered member of the Website and
						Mobile Apps (Member) and agree to be bound by the Terms.
					</p>
					<p className={styles["policy-text"]}>
						(e) You may not use the Services and may not accept the
						Terms if:
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(i) you are not of legal age to form a binding contract
						with Together Entertainment Pty Ltd; or
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(ii) you are a person barred from receiving the Services
						under the laws of Australia or other countries including
						the country in which you are resident or from which you
						use the Services.
					</p>
					<p className={styles["policy-text-section-title"]}>
						4. Your obligations as a Member
					</p>
					<p className={styles["policy-text"]}>
						(a) As a Member, you agree to comply with the following:
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(i) you will use the Services only for purposes that are
						permitted by:
					</p>
					<p className={styles["policy-A-indent-text"]}>
						(A) the Terms; and
					</p>
					<p className={styles["policy-A-indent-text"]}>
						(B) any applicable law, regulation or generally accepted
						practices or guidelines in the relevant jurisdictions;
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(ii) you have the sole responsibility for protecting the
						confidentiality of your password and/or email address.
						Use of your password by any other person may result in
						the immediate cancellation of the Services;
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(iii) any use of your registration information by any
						other person, or third parties, is strictly prohibited.
						You agree to immediately notify Together Entertainment
						Pty Ltd of any unauthorised use of your password or
						email address or any breach of security of which you
						have become aware;
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(iv) access and use of the Website is limited,
						non-transferable and allows for the sole use of the
						Website by you for the purposes of Together
						Entertainment Pty Ltd providing the Services;
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(v) you will not use the Services or the Website in
						connection with any commercial endeavours except those
						that are specifically endorsed or approved by the
						management of Together Entertainment Pty Ltd;
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(vi) you will not use the Services or Website for any
						illegal and/or unauthorised use which includes
						collecting email addresses of Members by electronic or
						other means for the purpose of sending unsolicited email
						or unauthorised framing of or linking to the Website;
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(vii) you agree that commercial advertisements,
						affiliate links, and other forms of solicitation may be
						removed from the Website without notice and may result
						in termination of the Services. Appropriate legal action
						will be taken by Together Entertainment Pty Ltd for any
						illegal or unauthorised use of the Website; and
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(viii) you acknowledge and agree that any automated use
						of the Website or its Services is prohibited.
					</p>
					<p className={styles["policy-text-section-title"]}>
						5. Copyright and Intellectual Property
					</p>
					<p className={styles["policy-text"]}>
						(a) The Website, the Services and all of the related
						products of Together Entertainment Pty Ltd are subject
						to copyright. The material on the Website is protected
						by copyright under the laws of Australia and through
						international treaties. Unless otherwise indicated, all
						rights (including copyright) in the Services and
						compilation of the Website (including but not limited to
						text, graphics, logos, button icons, video images, audio
						clips, Website code, scripts, design elements and
						interactive features) or the Services are owned or
						controlled for these purposes, and are reserved by
						Together Entertainment Pty Ltd or its contributors.
					</p>
					<p className={styles["policy-text"]}>
						(b) All trademarks, service marks and trade names are
						owned, registered and/or licensed by Together
						Entertainment Pty Ltd, who grants to you a worldwide,
						non-exclusive, royalty-free, revocable license whilst
						you are a Member to:
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(i) use the Website pursuant to the Terms;
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(ii) copy and store the Website and the material
						contained in the Website in your device's cache memory;
						and
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(iii) print pages from the Website for your own personal
						and non-commercial use.
					</p>
					<p className={styles["policy-text"]}>
						Together Entertainment Pty Ltd does not grant you any
						other rights whatsoever in relation to the Website or
						the Services. All other rights are expressly reserved by
						Together Entertainment Pty Ltd.
					</p>
					<p className={styles["policy-text"]}>
						(c) Together Entertainment Pty Ltd retains all rights,
						title and interest in and to the Website and all related
						Services. Nothing you do on or in relation to the
						Website will transfer any:
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(i) business name, trading name, domain name, trade
						mark, industrial design, patent, registered design or
						copyright, or
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(ii) a right to use or exploit a business name, trading
						name, domain name, trade mark or industrial design, or
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(iii) a thing, system or process that is the subject of
						a patent, registered design or copyright (or an
						adaptation or modification of such a thing, system or
						process).
					</p>
					<p className={styles["policy-text"]}>
						(d) You may not, without the prior written permission of
						Together Entertainment Pty Ltd and the permission of any
						other relevant rights owners: broadcast, republish,
						up-load to a third party, transmit, post, distribute,
						show or play in public, adapt or change in any way the
						Services or third party Services for any purpose, unless
						otherwise provided by these Terms. This prohibition does
						not extend to materials on the Website, which are freely
						available for re-use or are in the public domain.
					</p>
					<p className={styles["policy-text"]}>
						(e) You acknowledge and agree that all content and
						materials available on the Website are protected by
						copyrights, trademarks, service marks, patents, trade
						secrets, or other proprietary rights and laws. Except as
						expressly authorised by , you agree not to sell,
						license, rent, modify, distribute, copy, reproduce,
						transmit, publicly display, publicly perform, publish,
						adapt, edit, or create derivative works from such
						materials or content.
					</p>
					<p className={styles["policy-text"]}>
						(f) You agree to indemnify and hold harmless from any
						claim or demand, including reasonable attorneys' fees,
						made by any third party due to or arising out of your
						breach of these Terms, your violation of any law, or
						your violation of the rights of a third party.
					</p>
					<p className={styles["policy-text-section-title"]}>
						6. Privacy
					</p>
					<p className={styles["policy-text"]}>
						Together Entertainment Pty Ltd takes your privacy
						seriously and any information provided through your use
						of the Website and/or Services are subject to Together
						Entertainment Pty Ltd's Privacy Policy, which is
						available on the Website.
					</p>
					<p className={styles["policy-text-section-title"]}>
						7. General Disclaimer
					</p>
					<p className={styles["policy-text"]}>
						(a) Nothing in the Terms limits or excludes any
						guarantees, warranties, representations or conditions
						implied or imposed by law, including the Australian
						Consumer Law (or any liability under them) which by law
						may not be limited or excluded.
					</p>
					<p className={styles["policy-text"]}>
						(b) Subject to this clause, and to the extent permitted
						by law:
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(i) all terms, guarantees, warranties, representations
						or conditions which are not expressly stated in the
						Terms are excluded; and
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(ii) Together Entertainment Pty Ltd will not be liable
						for any special, indirect or consequential loss or
						damage (unless such loss or damage is reasonably
						foreseeable resulting from our failure to meet an
						applicable Consumer Guarantee), loss of profit or
						opportunity, or damage to goodwill arising out of or in
						connection with the Services or these Terms (including
						as a result of not being able to use the Services or the
						late supply of the Services), whether at common law,
						under contract, tort (including negligence), in equity,
						pursuant to statute or otherwise.
					</p>
					<p className={styles["policy-text"]}>
						(c) Use of the Website and the Services is at your own
						risk. Everything on the Website and the Services is
						provided to you "as is" and "as available" without
						warranty or condition of any kind. None of the
						affiliates, directors, officers, employees, agents,
						contributors and licensors of Together Entertainment Pty
						Ltd make any express or implied representation or
						warranty about the Services or any products or Services
						(including the products or Services of Together
						Entertainment Pty Ltd) referred to on the Website. This
						includes (but is not restricted to) loss or damage you
						might suffer as a result of any of the following:
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(i) failure of performance, error, omission,
						interruption, deletion, defect, failure to correct
						defects, delay in operation or transmission, computer
						virus or other harmful component, loss of data,
						communication line failure, unlawful third party
						conduct, or theft, destruction, alteration or
						unauthorised access to records;
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(ii) the accuracy, suitability or currency of any
						information on the Website, the Services, or any of its
						Services related products (including third party
						material and advertisements on the Website);
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(iii) costs incurred as a result of you using the
						Website, the Services or any of the products of Together
						Entertainment Pty Ltd; and
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(iv) the Services or operation in respect to links which
						are provided for your convenience.
					</p>
					<p className={styles["policy-text"]}>
						(d) Any dispute arising out of or in connection with
						these Terms, including any question regarding its
						existence, validity, or termination, shall be referred
						to and finally resolved by arbitration under the ACICA
						Arbitration Rules. The seat of arbitration shall be
						Sydney, Australia. The language of the arbitration shall
						be English. The number of arbitrators shall be one.
					</p>
					<p className={styles["policy-text-section-title"]}>
						8. Limitation of liability
					</p>
					<p className={styles["policy-text"]}>
						(a) Together Entertainment Pty Ltd's total liability
						arising out of or in connection with the Services or
						these Terms, however arising, including under contract,
						tort (including negligence), in equity, under statute or
						otherwise, will not exceed the resupply of the Services
						to you.
					</p>
					<p className={styles["policy-text"]}>
						(b) You expressly understand and agree that Together
						Entertainment Pty Ltd, its affiliates, employees,
						agents, contributors and licensors shall not be liable
						to you for any direct, indirect, incidental, special
						consequential or exemplary damages which may be incurred
						by you, however caused and under any theory of
						liability. This shall include, but is not limited to,
						any loss of profit (whether incurred directly or
						indirectly), any loss of goodwill or business reputation
						and any other intangible loss.
					</p>
					<p className={styles["policy-text-section-title"]}>
						9. Competitors
					</p>
					<p className={styles["policy-text"]}>
						If you are in the business of providing similar Services
						for the purpose of providing them to users for a
						commercial gain, whether business users or domestic
						users, then you are a competitor of Together
						Entertainment Pty Ltd. Competitors are not permitted to
						use or access any information or content on our
						Application. If you breach this provision, Together
						Entertainment Pty Ltd will hold you fully responsible
						for any loss that we may sustain and hold you
						accountable for all profits that you might make from
						such a breach.
					</p>
					<p className={styles["policy-text-section-title"]}>
						10. Indemnity
					</p>
					<p className={styles["policy-text"]}>
						You agree to indemnify Together Entertainment Pty Ltd,
						its affiliates, employees, agents, contributors, third
						party content providers and licensors from and against:
					</p>
					<p className={styles["policy-text"]}>
						(a) all actions, suits, claims, demands, liabilities,
						costs, expenses, loss and damage (including legal fees
						on a full indemnity basis) incurred, suffered or arising
						out of or in connection with your content;
					</p>
					<p className={styles["policy-text"]}>
						(b) any direct or indirect consequences of you
						accessing, using or transacting on the Website or
						attempts to do so; and/or
					</p>
					<p className={styles["policy-text"]}>
						(c) any breach of the Terms.
					</p>

					<p className={styles["policy-text-section-title"]}>
						11. Dispute Resolution
					</p>
					<p className={styles["policy-text-subsection-title"]}>
						11.1. Compulsory:
					</p>
					<p className={styles["policy-i-indent-text"]}>
						If a dispute arises out of or relates to the Terms,
						either party may not commence any Tribunal or Court
						proceedings in relation to the dispute, unless the
						following clauses have been complied with (except where
						urgent interlocutory relief is sought).
					</p>
					<p className={styles["policy-text-subsection-title"]}>
						11.2. Notice:
					</p>
					<p className={styles["policy-i-indent-text"]}>
						A party to the Terms claiming a dispute (Dispute) has
						arisen under the Terms, must give written notice to the
						other party detailing the nature of the dispute, the
						desired outcome and the action required to settle the
						Dispute.
					</p>
					<p className={styles["policy-text-subsection-title"]}>
						11.3. Resolution:
					</p>
					<p className={styles["policy-i-indent-text"]}>
						On receipt of that notice (Notice) by that other party,
						the parties to the Terms (Parties) must:
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(a) Within 28 days of the Notice endeavour in good faith
						to resolve the Dispute expeditiously by negotiation or
						such other means upon which they may mutually agree;
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(b) If for any reason whatsoever, 28 days after the date
						of the Notice, the Dispute has not been resolved, the
						Parties must either agree upon selection of a mediator
						or request that an appropriate mediator be appointed by
						the Australian Mediation Association (AMA);
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(c) The Parties are equally liable for the fees and
						reasonable expenses of a mediator and the cost of the
						venue of the mediation and without limiting the
						foregoing undertake to pay any amounts requested by the
						mediator as a precondition to the mediation commencing.
						The Parties must each pay their own costs associated
						with the mediation;
					</p>
					<p className={styles["policy-i-indent-text"]}>
						(d) The mediation will be held in Sydney, Australia.
					</p>
					<p className={styles["policy-text-subsection-title"]}>
						11.4. Confidential:
					</p>
					<p className={styles["policy-i-indent-text"]}>
						All communications concerning negotiations made by the
						Parties arising out of and in connection with this
						dispute resolution clause are confidential and to the
						extent possible, must be treated as "without prejudice"
						negotiations for the purpose of applicable laws of
						evidence.
					</p>
					<p className={styles["policy-text-subsection-title"]}>
						11.5. Termination of Mediation:
					</p>
					<p className={styles["policy-i-indent-text"]}>
						If 2 months have elapsed after the start of a mediation
						of the Dispute and the Dispute has not been resolved,
						either Party may ask the mediator to terminate the
						mediation and the mediator must do so.
					</p>
					<p className={styles["policy-text-section-title"]}>
						12. Venue and Jurisdiction
					</p>
					<p className={styles["policy-text"]}>
						The Services offered by Together Entertainment Pty Ltd
						is intended to be viewed by residents of Australia. In
						the event of any dispute arising out of or in relation
						to the Website, you agree that the exclusive venue for
						resolving any dispute shall be in the courts of New
						South Wales, Australia.
					</p>
					<p className={styles["policy-text-section-title"]}>
						13. Governing Law
					</p>
					<p className={styles["policy-text"]}>
						The Terms are governed by the laws of New South Wales,
						Australia. Any dispute, controversy, proceeding or claim
						of whatever nature arising out of or in any way relating
						to the Terms and the rights created hereby shall be
						governed, interpreted and construed by, under and
						pursuant to the laws of New South Wales, Australia,
						without reference to conflict of law principles,
						notwithstanding mandatory rules. The validity of this
						governing law clause is not contested. The Terms shall
						be binding to the benefit of the parties hereto and
						their successors and assigns.
					</p>
					<p className={styles["policy-text-section-title"]}>
						14. Severance
					</p>
					<p className={styles["policy-text"]}>
						If any part of these Terms is found to be void or
						unenforceable by a Court of competent jurisdiction, that
						part shall be severed and the rest of the Terms shall
						remain in force.
					</p>
				</div>
			</main>
		</div>
	);
}
